// src/contexts/PusherContext.tsx
import React, { createContext, useEffect, useState, useContext } from 'react';
import Pusher, { Channel } from 'pusher-js';
import { User } from 'src/models/user';

interface PusherContextType {
  pusher: Pusher | null;
  channel: Channel | null;
  login: User | null;
}

const PusherContext = createContext<PusherContextType>({
  pusher: null,
  channel: null,
  login: null,
});

export const PusherProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [pusher, setPusher] = useState<Pusher | null>(null);
  const [channel, setChannel] = useState<Channel | null>(null);
  const [login, setLogin] = useState<User | null>(null);

  useEffect(() => {
    Pusher.logToConsole = true;

    const pusherInstance = new Pusher('b04be7fe5f8c4c35ac35', {
      cluster: 'mt1',
    });

    const pusherChannel = pusherInstance.subscribe('logins');

    pusherChannel.bind('user.logged.in', (data: any) => {
      console.log(JSON.stringify(data));
      setLogin(data)
    });

    setPusher(pusherInstance);
    setChannel(pusherChannel);

    return () => {
      pusherChannel.unbind_all();
      pusherChannel.unsubscribe();
      pusherInstance.disconnect();
    };
  }, []);

  return (
    <PusherContext.Provider value={{ pusher, channel,login }}>
      {children}
    </PusherContext.Provider>
  );
};

export const usePusher = () => useContext(PusherContext);
